/**
 * 广告位列表
 */
import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { message } from 'antd';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import { XInput, XOKButton, XCancelButton, XSelect } from '@/components/xqxc_ui';
import model from '@/reducers/client/baseset/slide/model';
import TableList from './components/TableList';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';
import { setSessionStorage } from '@/assets/js/storage';
import { TableAction as ta } from '../types';

class Main extends React.Component {

    state = {
        state: {},
        adSpaceName: '',
        pageNum: 1,
        pageSize: 10
    }

    componentDidMount() {
        this.props.getStateList({ enumName: 'StateEnum' });
    }

    // 查询
    _searchHandle = (useCache) => {
        const { adSpaceName, state, pageNum, pageSize } = this.state;
        this.searchCache = {
            name: adSpaceName,
            state: state.code,
            showPort: this.props.curTabID,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getTableSource(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }

    // 重置
    _resetHandle = () => {
        this.setState({ adSpaceName: '', state: {}, pageNum: 1, pageSize: 10 }, () => {
            KeepAlive.saveResetFunc(this._searchHandle); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }

    // 新建广告
    _newHandle = () => {
        const { history } = this.props;
        history.push({
            pathname: '/home/advertmanage/advertList/add'
        });
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageNum, pageSize }, () => {
            this._searchHandle('useCache');
        });
    }

    // 表格操作
    _tableAction = (key, type, item) => {
        const { history, curTabID } = this.props;
        switch (type) {
            case ta.manage:
                setSessionStorage('clientBaseSetSlideCurTabID', curTabID);
                history.push({
                    pathname: `/home/client/baseset/slide/manage/${curTabID},${item.id}`,
                    search: `positionName=${item.showPortName} - ${item.name}`
                });
                break;
            case ta.adPosition:
                setSessionStorage('clientBaseSetSlideCurTabID', curTabID);
                history.push({
                    pathname: `/home/client/baseset/slide/manage/${curTabID},${item.id}`,
                    search: `positionName=${item.showPortName} - ${item.name}`
                });
                break;
            case ta.state:
                http('/?cmd=com.xqxc.api.pig.mis.biz.platform.ad.AdvertSpaceMisService.updateState', {//状态
                    id: item.id,
                    status: key,
                }, 'POST').then(() => {
                    message.success('修改成功');
                    this._searchHandle('useCache');
                }).catch((reject = {}) => message.error(reject.message));
                break;
        }
    }

    render() {
        const { adSpaceName, state } = this.state;
        let { tableSource, stateList, curTabID } = this.props;

        return (
            <KeepAlive id={curTabID} render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: '200px' }}
                                label='广告位名称'
                                placeholder='请输入'
                                value={adSpaceName}
                                bindThis={this}
                                bindName='adSpaceName'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                selectStyle={{ width: '200px' }}
                                label='状态'
                                placeholder='请选择'
                                renderData={stateList}
                                dataIndex='value'
                                keyIndex='code'
                                value={state.value}
                                bindThis={this}
                                bindName='state'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <TableList renderData={tableSource} tableAction={this._tableAction} paginationChange={this._paginationChange} />
                </div>
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,
    curTabID: PropTypes.string,

    getTableSource: PropTypes.func,
    tableSource: PropTypes.object,

    getStateList: PropTypes.func,
    stateList: PropTypes.array
};
const mapStateToProps = (state) => ({
    stateList: state.baseset_slide.stateList,
    tableSource: state.baseset_slide.tableSource
});

export default connect(mapStateToProps, { ...model.actions })(Main);